import { render, staticRenderFns } from "./NotificationsDropdownItem.vue?vue&type=template&id=5e9eb656&"
import script from "./NotificationsDropdownItem.vue?vue&type=script&lang=js&"
export * from "./NotificationsDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports